import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router: Router = inject(Router);
  const toastService: ToastService = inject(ToastService);
  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          // Handle 401 error (Unauthorized)
          // Reconnect is handled in auto-login.interceptor.ts
          toastService.add({ severity: 'warn', summary: 'Erreur 401', detail: `Vous devez êtes connecté pour effectuer cette action.`, life: 10000 })
        } else if (err.status === 403) {
          // Handle 403 error (Forbidden)
          // Reconnect is handled in auto-login.interceptor.ts
          toastService.add({ severity: 'warn', summary: 'Erreur 403', detail: `Vous n'avez pas les droits pour effectuer cette action.`, life: 10000 })
        } else if (err.status === 404) {
          // Handle 404 error (Not Found)
          router.navigate(['/404'])
        } else if (err.status === 422) {
          // Handle 422 error (Bad formated data)
          const errorDetail = err.error?.detail ? err.error.detail : `Les données envoyées ne correspondent pas à ce qui est attendu.`;
          toastService.add({ severity: 'error', summary: 'Erreur 422', detail: errorDetail, life: 10000 })
        } else if (err.status >= 500) {
          // Handle server errors
          toastService.add({ severity: 'error', summary: 'Erreur 500', detail: `Le serveur a rencontré un problème.\nSi cela persiste merci de contacter un administrateur.`, life: 10000 })
        } else {
          toastService.add({ severity: 'warn', summary: 'Erreur inconnue', detail: `Une erreur est survenue.\nLe fantôme de la machine vous joue des tours.`, life: 10000 })
        }
      }
      return throwError(() => err)
    })
  );
};
